// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const insertAt = (text, toInsert, start, end = start) => text.slice(0, start) + toInsert + text.slice(end);
//# sourceMappingURL=strings.js.map